import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Star, Heart, Gift, AlertCircle, Sparkles, ChevronLeft, ChevronRight } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { BonusCard } from '../components/BonusCard';
import { TestimonialCard } from '../components/TestimonialCard';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { FAQ } from '../components/FAQ';
import { Flame, Clock, ShieldCheck, Zap, Layout, BookOpen, RefreshCw } from 'lucide-react';
export function LandingPage() {
  const fadeInUp = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = ['https://cdn.magicpatterns.com/uploads/7BiU6DqDu6wBM5qYDY5Gxv/MAS.jpg', 'https://cdn.magicpatterns.com/uploads/2Gj4DAKysis3hg9wXEQWUv/PRINCESAS.jpg', 'https://cdn.magicpatterns.com/uploads/eRwzx9M7k6nF54KKJQKc51/BAUTISMO.jpg', 'https://cdn.magicpatterns.com/uploads/9VvzFVv48hwAEFmdQzo6r5/MIKEY.jpg'];
  const nextSlide = () => setCurrentSlide(prev => (prev + 1) % slides.length);
  const prevSlide = () => setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    const element = document.getElementById('purchase-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="min-h-screen bg-gradient-to-b from-pink-50 via-purple-50 to-blue-50 font-sans text-gray-800 overflow-x-hidden" data-id="element-70">
      <SocialProofPopup data-id="element-71" />

      {/* Urgency Bar - Single Line, No Scroll */}
      <div className="bg-gradient-to-r from-pink-100 via-purple-100 to-pink-100 text-purple-900 py-0.5 text-center sticky top-0 z-50 shadow-sm border-b border-purple-200" data-id="element-72">
        <div className="px-2" data-id="element-73">
          <p className="text-[8px] md:text-[9px] font-bold" data-id="element-74">
            ÚLTIMAS HORAS: 60% DE DESCUENTO + BONOS GRATIS • Quedan 3 cupos
          </p>
        </div>
      </div>

      {/* Hero Section - Optimized for First Screen */}
      <header className="relative pt-2 pb-3 px-4 md:pt-6 md:pb-8" data-id="element-75">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-20" data-id="element-76">
          <div className="absolute top-10 left-10 w-32 h-32 bg-pink-300 rounded-full blur-3xl" data-id="element-77"></div>
          <div className="absolute bottom-10 right-10 w-48 h-48 bg-blue-300 rounded-full blur-3xl" data-id="element-78"></div>
        </div>

        <div className="max-w-4xl mx-auto text-center" data-id="element-79">
          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-xl md:text-3xl lg:text-4xl font-extrabold text-gray-900 leading-tight mb-1.5 uppercase" data-id="element-80">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600" data-id="element-81">
              MEGA PACK GLOBOLOGÍA
            </span>
          </motion.h1>

          {/* Promise - Larger Size */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-sm md:text-base text-gray-700 mb-1.5 max-w-2xl mx-auto font-medium leading-snug px-2" data-id="element-82">
            Convertite en una decoradora profesional sin improvisar: aprendé
            globología completa, candy bar y cobrá eventos reales.
          </motion.p>

          {/* Compact Social Proof - No Box, Single Line */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="flex justify-center mb-1.5" data-id="element-83">
            <div className="inline-flex items-center gap-1 text-[8px] md:text-[9px]" data-id="element-84">
              <div className="flex -space-x-0.5" data-id="element-85">
                {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-3 h-3 rounded-full border border-white bg-gray-200 overflow-hidden" data-id="element-86">
                    <img src={`https://randomuser.me/api/portraits/women/${30 + i}.jpg`} alt="User" className="w-full h-full object-cover" data-id="element-87" />
                  </div>)}
              </div>
              <div className="flex items-center gap-0.5" data-id="element-88">
                <div className="flex" data-id="element-89">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-1.5 h-1.5 text-yellow-400 fill-yellow-400" data-id="element-90" />)}
                </div>
                <span className="font-bold text-gray-800" data-id="element-91">4.9/5</span>
                <span className="text-gray-600" data-id="element-92">
                  • +1200 decoradoras ya usan este método
                </span>
              </div>
            </div>
          </motion.div>

          {/* Mockup - Larger, No White Background, Links to Purchase */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.3
        }} className="relative w-[65%] max-w-[240px] mx-auto mb-2" data-id="element-93">
            <a href="#purchase-section" onClick={scrollToPurchase} className="block" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/8AeQZRNVFDb2RAr4DUWP1j/6b331946-5fb0-485f-b7b7-baada5109c67.jpg" alt="Mega Pack Globología Mágica Pro" className="w-full" data-id="element-95" />
            </a>
          </motion.div>

          {/* Subtitle - Larger, More Prominent */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-xs md:text-sm text-gray-800 mb-3 max-w-2xl mx-auto leading-relaxed px-2 font-semibold" data-id="element-96">
            El Mega Pack Globología Mágica Pro es el sistema completo para
            aprender globología paso a paso, decorar eventos reales y empezar a
            cobrar con seguridad.
          </motion.p>

          {/* CTA - Smaller, More Minimal */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="flex justify-center" data-id="element-97">
            <a href="#purchase-section" onClick={scrollToPurchase} className="inline-flex items-center justify-center gap-1.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold text-xs uppercase tracking-wide py-2 px-6 rounded-full shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300 ease-out w-[70%] max-w-[280px]" data-id="element-98">
              QUIERO VER LA OFERTA
            </a>
          </motion.div>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-10 px-4 bg-white relative" data-id="element-99">
        <div className="max-w-4xl mx-auto" data-id="element-100">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeInUp} className="text-center" data-id="element-101">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-5" data-id="element-102">
              ¿Te piden un evento… y lo primero que sentís es{' '}
              <span className="text-pink-600" data-id="element-103">miedo</span>?
            </h2>

            <div className="bg-red-50 p-5 rounded-2xl border border-red-100 mb-6 text-left md:text-center" data-id="element-104">
              <p className="font-medium text-sm text-gray-700 mb-2" data-id="element-105">
                Miedo a comprar mal, a combinar colores que no funcionen, a
                tardar demasiado o a que no quede prolijo.
              </p>
              <p className="font-bold text-base text-red-800" data-id="element-106">
                Y sobre todo, miedo a decir un precio… y sentir que estás
                improvisando.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-5 items-center mb-6 text-left" data-id="element-107">
              <div data-id="element-108">
                <h3 className="text-base font-bold text-purple-900 mb-2" data-id="element-109">
                  La diferencia entre improvisar y ser profesional
                </h3>
                <p className="text-gray-600 text-xs mb-2" data-id="element-110">
                  Hay decoradoras que trabajan tranquilas, seguras y cobran sin
                  dudar. No tienen más talento que vos, simplemente{' '}
                  <strong data-id="element-111">tienen un método.</strong>
                </p>
                <p className="text-gray-600 text-xs" data-id="element-112">
                  Sin un sistema, cada evento es una apuesta. Con el Mega Pack,
                  tenés el paso a paso para dejar de dudar.
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-xl border border-gray-100" data-id="element-113">
                <ul className="space-y-2" data-id="element-114">
                  {['¿Qué estructura conviene usar?', '¿Cuántos globos comprar?', '¿Cómo combinar colores?', '¿Cómo cobrar sin culpa?'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700 text-xs font-medium" data-id="element-115">
                      <AlertCircle className="w-3 h-3 text-pink-500 flex-shrink-0" data-id="element-116" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>

            <CTAButton scrollTo="purchase-section" data-id="element-117">
              QUIERO LOGRAR ESTO
            </CTAButton>
          </motion.div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-10 px-4 bg-gradient-to-b from-purple-900 to-indigo-900 text-white" data-id="element-118">
        <div className="max-w-4xl mx-auto text-center" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-120">
            <h2 className="text-xl md:text-2xl font-bold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-pink-300 to-purple-300" data-id="element-121">
              El problema no son los globos, es la falta de un sistema.
            </h2>

            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-5 md:p-6 border border-white/20 shadow-2xl mt-5" data-id="element-122">
              <div className="flex justify-center mb-3" data-id="element-123">
                <div className="bg-pink-500 text-white font-bold px-4 py-1 rounded-full text-xs shadow-lg" data-id="element-124">
                  LA SOLUCIÓN DEFINITIVA
                </div>
              </div>

              <h3 className="text-2xl md:text-3xl font-extrabold mb-3 text-white drop-shadow-lg" data-id="element-125">
                Mega Pack Globología Mágica Pro
              </h3>
              <p className="text-sm mb-5 text-purple-100 max-w-2xl mx-auto" data-id="element-126">
                Un pack digital completo donde aprendés a convertir la
                globología y la decoración de eventos en un servicio rentable,
                ordenado y profesional.
              </p>

              <CTAButton scrollTo="purchase-section" className="text-purple-900 bg-white hover:bg-gray-100 border-none" data-id="element-127">
                QUIERO VER LA OFERTA
              </CTAButton>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Photo Slider - Replaces Video */}
      <section className="py-12 px-4 bg-white" data-id="element-128">
        <div className="max-w-5xl mx-auto" data-id="element-129">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-8" data-id="element-130">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-131">
              Este es el tipo de eventos que vas a poder armar con el método.
            </h2>
            <p className="text-gray-600 text-xs" data-id="element-132">
              Resultados reales y alcanzables para quienes están aprendiendo
            </p>
          </motion.div>

          {/* Slider */}
          <div className="relative max-w-3xl mx-auto" data-id="element-133">
            <div className="overflow-hidden rounded-2xl" data-id="element-134">
              <motion.img key={currentSlide} src={slides[currentSlide]} alt={`Evento ${currentSlide + 1}`} className="w-full h-auto" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5
            }} data-id="element-135" />
            </div>

            <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all" data-id="element-136">
              <ChevronLeft className="w-5 h-5 text-gray-800" data-id="element-137" />
            </button>
            <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all" data-id="element-138">
              <ChevronRight className="w-5 h-5 text-gray-800" data-id="element-139" />
            </button>

            <div className="flex justify-center gap-2 mt-4" data-id="element-140">
              {slides.map((_, i) => <button key={i} onClick={() => setCurrentSlide(i)} className={`w-2 h-2 rounded-full transition-all ${i === currentSlide ? 'bg-purple-600 w-6' : 'bg-gray-300'}`} data-id="element-141" />)}
            </div>
          </div>

          {/* What You Can Do */}
          <div className="mt-12 max-w-5xl mx-auto" data-id="element-142">
            <h3 className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-6" data-id="element-143">
              Con el Mega Pack Globología Mágica vas a poder:
            </h3>
            <div className="grid md:grid-cols-2 gap-3" data-id="element-144">
              {[{
              text: 'Hacer arcos perfectos sin que se desarmen',
              icon: '🎈'
            }, {
              text: 'Crear figuras infantiles y animales',
              icon: '🦄'
            }, {
              text: 'Armar columnas, flores, personajes y estructuras complejas',
              icon: '🏗️'
            }, {
              text: 'Diseñar mesas de Candy Bar completas',
              icon: '🍬'
            }, {
              text: 'Combinar colores de forma profesional',
              icon: '🎨'
            }, {
              text: 'Presupuestar eventos sin dudar',
              icon: '💰'
            }, {
              text: 'Entregar trabajos profesionales aunque seas principiante',
              icon: '🎓'
            }, {
              text: 'Preparar decoraciones rápidas para trabajos urgentes',
              icon: '⚡'
            }].map((item, i) => <div key={i} className="flex items-start gap-2 bg-purple-50 p-3 rounded-xl border border-purple-100" data-id="element-145">
                  <span className="text-lg" data-id="element-146">{item.icon}</span>
                  <span className="text-gray-800 font-medium text-xs" data-id="element-147">
                    {item.text}
                  </span>
                </div>)}
            </div>
          </div>

          {/* What's Included - EXACT STRUCTURE */}
          <div className="mt-12 max-w-6xl mx-auto bg-white rounded-3xl p-5 md:p-8 border-2 border-purple-100 shadow-xl" data-id="element-148">
            <h3 className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-6" data-id="element-149">
              Qué incluye exactamente el Mega Pack Globología Mágica Pro
            </h3>

            {/* Top Row - 3 Large Items */}
            <div className="grid md:grid-cols-3 gap-4 mb-5" data-id="element-150">
              {[{
              icon: <Zap className="w-8 h-8 text-purple-500" data-id="element-151" />,
              title: 'Curso completo de Decoración de Eventos',
              desc: 'Videos + PDF paso a paso'
            }, {
              icon: <Layout className="w-8 h-8 text-blue-500" data-id="element-152" />,
              title: 'Curso completo de Globología paso a paso',
              desc: 'Desde cero, técnicas claras y aplicables'
            }, {
              icon: <Star className="w-8 h-8 text-yellow-500" data-id="element-153" />,
              title: 'Curso completo de Mesas Dulces & Candy Bar',
              desc: 'Diseño y armado profesional'
            }].map((item, i) => <div key={i} className="flex flex-col items-center text-center gap-2 p-4 rounded-xl bg-purple-50 border border-purple-100" data-id="element-154">
                  <div className="bg-white p-2 rounded-full shadow-sm" data-id="element-155">
                    {item.icon}
                  </div>
                  <div data-id="element-156">
                    <h4 className="font-bold text-sm text-gray-900 leading-tight mb-1" data-id="element-157">
                      {item.title}
                    </h4>
                    <p className="text-[10px] text-gray-600" data-id="element-158">{item.desc}</p>
                  </div>
                </div>)}
            </div>

            {/* Bottom Row - 4 Medium Items */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-id="element-159">
              {[{
              icon: <ShieldCheck className="w-6 h-6 text-green-500" data-id="element-160" />,
              title: 'Negocio rentable',
              desc: 'Cómo presupuestar y cobrar eventos'
            }, {
              icon: <Gift className="w-6 h-6 text-orange-500" data-id="element-161" />,
              title: 'Figuras y personajes',
              desc: 'Animales, flores y muñecos'
            }, {
              icon: <BookOpen className="w-6 h-6 text-pink-500" data-id="element-162" />,
              title: 'Organización',
              desc: 'Guías para gestionar eventos sin estrés'
            }, {
              icon: <Check className="w-6 h-6 text-indigo-500" data-id="element-163" />,
              title: 'Plantillas y personajes editables',
              desc: 'Editables en PowerPoint y Canva'
            }].map((item, i) => <div key={i} className="flex flex-col items-center text-center gap-1.5 p-2 rounded-xl hover:bg-gray-50 transition-colors border border-gray-100" data-id="element-164">
                  <div className="bg-gray-100 p-1.5 rounded-full" data-id="element-165">
                    {item.icon}
                  </div>
                  <div data-id="element-166">
                    <h4 className="font-bold text-[10px] md:text-xs text-gray-900 leading-tight" data-id="element-167">
                      {item.title}
                    </h4>
                    <p className="text-[9px] text-gray-600 mt-0.5" data-id="element-168">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Target Audience */}
      <section className="py-12 px-4 bg-pink-50" data-id="element-169">
        <div className="max-w-4xl mx-auto" data-id="element-170">
          <h2 className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-8" data-id="element-171">
            Esto es para vos si…
          </h2>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-172">
            {['Querés empezar desde cero, pero no querés perder tiempo improvisando.', 'Ya decorás eventos, pero no sabés cuánto cobrar.', 'Sentís que te falta orden y seguridad.', 'Querés generar ingresos reales con decoración.', 'Estás cansada de trabajar mucho y ganar poco.', 'Querés sentirte profesional, aunque hoy te sientas amateur.'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-4 rounded-xl shadow-sm border border-pink-100 flex items-center gap-3" data-id="element-173">
                <div className="bg-pink-100 p-1.5 rounded-full" data-id="element-174">
                  <Heart className="w-3 h-3 text-pink-500" data-id="element-175" />
                </div>
                <p className="font-medium text-gray-700 text-xs" data-id="element-176">{item}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-12 px-4 bg-gradient-to-b from-white to-purple-50 relative overflow-hidden" data-id="element-177">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl" data-id="element-178">
          <div className="bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 text-white py-1.5 px-6 text-center font-bold text-[10px] md:text-xs tracking-wide shadow-lg animate-pulse" data-id="element-179">
            🎁 OFERTA ESPECIAL POR TIEMPO LIMITADO
          </div>
        </div>

        <div className="max-w-6xl mx-auto pt-8" data-id="element-180">
          <div className="text-center mb-10" data-id="element-181">
            <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-2" data-id="element-182">
              Regalos Exclusivos
            </h2>
            <p className="text-base text-purple-600 font-medium" data-id="element-183">
              Gratis con tu compra hoy
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-5 mb-10" data-id="element-184">
            <BonusCard image="https://cdn.magicpatterns.com/uploads/uq8Ym4Ws7WM389REmdubso/Bono_1.png" title="Bono 1: Curso de Diseño Gráfico" description="Aprendé diseño gráfico aplicado al Candy Bar para crear decoraciones profesionales y atractivas." delay={0.1} data-id="element-185" />
            <BonusCard image="https://cdn.magicpatterns.com/uploads/15zSeDofzVaY1MudHG297e/Bono_2.png" title="Bono 2: Pack de Instalación" description="Instalador de Corel Draw 2025 y PowerPoint para que empieces a diseñar desde el primer día." delay={0.2} data-id="element-186" />
            <BonusCard image="https://cdn.magicpatterns.com/uploads/fowpgJm3akp3d4QM6rtD6Z/Bono_3.png" title="Bono 3: 500 Personajes" description="500 personajes editables para Candy Bar, listos para usar en Canva y PowerPoint." delay={0.3} data-id="element-187" />
          </div>

          <div className="max-w-4xl mx-auto flex justify-center" data-id="element-188">
            <CTAButton scrollTo="purchase-section" data-id="element-189">
              QUIERO VER LA OFERTA
            </CTAButton>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-12 px-4 bg-gradient-to-b from-green-50 to-white" data-id="element-190">
        <div className="max-w-3xl mx-auto" data-id="element-191">
          <div className="bg-white rounded-3xl p-5 md:p-8 shadow-xl border-2 border-green-200" data-id="element-192">
            <div className="flex flex-col md:flex-row items-center gap-4 text-center md:text-left" data-id="element-193">
              <div className="bg-green-100 p-4 rounded-full flex-shrink-0" data-id="element-194">
                <ShieldCheck className="w-10 h-10 text-green-600" data-id="element-195" />
              </div>
              <div className="flex-grow" data-id="element-196">
                <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-197">
                  🛡 Garantía de Satisfacción Sin Preguntas – 7 Días
                </h3>
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-198">
                  Si en los próximos 7 días sentís que el pack no es para vos,
                  te devolvemos tu dinero sin preguntas. Queremos que estés 100%
                  segura de tu decisión.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PURCHASE SECTION - Like Biology Example */}
      <section id="purchase-section" className="py-12 px-4 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 text-white relative overflow-hidden scroll-mt-20" data-id="element-199">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-200">
          <h2 className="text-xl md:text-3xl font-bold mb-6" data-id="element-201">
            ¿Lista para dejar de improvisar?
          </h2>

          <div className="bg-white text-gray-900 rounded-3xl p-5 md:p-8 shadow-2xl max-w-lg mx-auto" data-id="element-202">
            {/* Pills Above Price */}
            <div className="flex flex-wrap justify-center gap-1.5 mb-5" data-id="element-203">
              {['🎈 Principiantes', '🎉 Intermedias', '💰 Emprendedoras', '🛍 Decoradoras en crecimiento'].map((tag, i) => <span key={i} className="bg-purple-100 text-purple-700 text-[9px] font-bold px-2 py-0.5 rounded-full border border-purple-200" data-id="element-204">
                  {tag}
                </span>)}
            </div>

            <h3 className="text-lg md:text-xl font-bold mb-5" data-id="element-205">
              Mega Pack Globología Mágica Pro + 3 Bonos
            </h3>

            {/* What You Get Today List */}
            <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-4 mb-5 text-left" data-id="element-206">
              <h4 className="font-bold text-sm text-green-800 mb-3 text-center" data-id="element-207">
                LO QUE RECIBÍS HOY:
              </h4>
              <ul className="space-y-1.5 text-xs text-gray-700" data-id="element-208">
                {['Curso completo de globología paso a paso', 'Curso completo de mesas dulces y candy bar', 'Curso de decoración de eventos', 'Plantillas editables', 'Figuras, flores, animales', 'Organización y presupuestos', 'Acceso de por vida', 'Actualizaciones gratis', '3 bonos incluidos'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-209">
                    <Check className="w-3 h-3 text-green-600 flex-shrink-0" data-id="element-210" />
                    <span data-id="element-211">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Price Display */}
            <div className="flex flex-col items-center justify-center mb-4" data-id="element-212">
              <div className="flex items-center gap-2 mb-1" data-id="element-213">
                <span className="text-gray-400 line-through text-base" data-id="element-214">
                  $49.990
                </span>
                <span className="bg-red-100 text-red-600 text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-215">
                  60% OFF
                </span>
              </div>
              <div className="flex items-start" data-id="element-216">
                <span className="text-xl font-bold mt-1" data-id="element-217">$</span>
                <span className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-pink-600 to-purple-600" data-id="element-218">
                  19.990
                </span>
                <span className="text-base font-bold mt-5 ml-1 text-gray-500" data-id="element-219">
                  ARS
                </span>
              </div>
            </div>

            {/* Pills Below Price */}
            <div className="flex flex-wrap justify-center gap-1.5 mb-5 text-[9px] font-bold text-purple-700" data-id="element-220">
              <span className="flex items-center gap-0.5 bg-purple-50 px-2 py-0.5 rounded-md" data-id="element-221">
                ⭐ Acceso de por vida
              </span>
              <span className="flex items-center gap-0.5 bg-purple-50 px-2 py-0.5 rounded-md" data-id="element-222">
                ♻️ Actualizaciones gratis
              </span>
              <span className="flex items-center gap-0.5 bg-purple-50 px-2 py-0.5 rounded-md" data-id="element-223">
                🎁 Incluye 3 bonos
              </span>
            </div>

            {/* CTA to Checkout */}
            <CTAButton fullWidth className="animate-pulse mb-2 text-base md:text-lg py-3" data-id="element-224">
              SÍ, QUIERO MI MEGAPACK AHORA
            </CTAButton>

            <p className="text-xs text-gray-500 font-medium mb-5" data-id="element-225">
              Acceso inmediato + Garantía total de 7 días
            </p>

            {/* Mercado Pago Logo - Larger */}
            <div className="mt-5 flex flex-col items-center gap-2" data-id="element-226">
              <p className="text-xs font-bold text-gray-700" data-id="element-227">
                Pago 100% seguro procesado por Mercado Pago
              </p>
              <img src="https://cdn.magicpatterns.com/uploads/tkuqXfKJKrRMaPRAAtZJ3N/mercado-pago-logo-png_seeklogo-342347.png" alt="Mercado Pago" className="h-16 object-contain" data-id="element-228" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 px-4 bg-white" data-id="element-229">
        <FAQ data-id="element-230" />
      </section>

      {/* Testimonials */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-231">
        <div className="max-w-6xl mx-auto" data-id="element-232">
          <h2 className="text-xl md:text-2xl font-bold text-center text-gray-900 mb-3" data-id="element-233">
            Ellas ya están facturando con sus eventos
          </h2>
          <div className="flex justify-center mb-8" data-id="element-234">
            <span className="bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-2 animate-pulse" data-id="element-235">
              👀 124 personas están viendo esta página ahora
            </span>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-236">
            <TestimonialCard name="Mariana G." location="Salta, Argentina" text="Antes me daba pánico pasar un presupuesto. Con el método del pack, ahora sé exactamente cuánto cobrar. ¡Recuperé la inversión en mi primer evento!" tag="Más ingresos" delay={0.1} data-id="element-237" />
            <TestimonialCard name="Lucía R." location="Mendoza, Argentina" text="Los bonos son increíbles. No sabía nada de diseño y con el curso de regalo pude armar mis propias etiquetas. Mis mesas quedaron hermosas." tag="Eventos más prolijos" delay={0.2} data-id="element-238" />
            <TestimonialCard name="Carolina M." location="Rosario, Santa Fe" text="Lo que más me sirvió fue la parte de organización. Vivía corriendo a último momento. Ahora tengo todo planificado." tag="Más seguridad" delay={0.3} data-id="element-239" />
            <TestimonialCard name="Valentina S." location="CABA, Buenos Aires" text="Empecé sin saber inflar un globo. Las explicaciones son súper claras. Ya hice 3 cumpleaños y todos quedaron encantados." tag="Ideal principiantes" delay={0.4} data-id="element-240" />
            <TestimonialCard name="Sofía L." location="La Plata, Buenos Aires" text="Llevaba años decorando pero sentía que mis trabajos se veían 'caseros'. Con las técnicas de estructuras prolijas, mis arcos ahora parecen de revista." tag="Más clientes" delay={0.5} data-id="element-241" />
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-12 px-4 bg-white text-center" data-id="element-242">
        <div className="max-w-3xl mx-auto" data-id="element-243">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3" data-id="element-244">
            No es magia. Es un sistema.
          </h2>
          <p className="text-base text-gray-600 mb-5" data-id="element-245">
            Mega Pack Globología Mágica Pro no promete resultados irreales.
            Promete algo mejor: orden, claridad y un método que se puede
            repetir.
          </p>
          <p className="text-sm font-bold text-purple-700 mb-6" data-id="element-246">
            Y los sistemas se repiten. Se cobran. Y se pueden hacer crecer.
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-247">
            <CTAButton className="text-lg px-10 py-4" data-id="element-248">
              👉 QUIERO EL PACK AHORA
            </CTAButton>
            <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-249">
              <Gift className="w-3 h-3" data-id="element-250" />
              <span data-id="element-251">Incluye los 3 bonos gratis hoy</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-xs" data-id="element-252">
        <p data-id="element-253">
          © 2024 Mega Pack Globología Mágica Pro. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-254">
          Este producto no garantiza resultados económicos. El éxito depende de
          tu dedicación y esfuerzo.
        </p>
      </footer>
    </div>;
}